import create from 'zustand';

export interface IState {
  onlyDevelopers: boolean;
  setOnlyDevelopers: (onlyDevelopers: boolean) => void;
}

const useOnlyDevelopers = create<IState>(set => ({
  onlyDevelopers: false,
  setOnlyDevelopers: onlyDevelopers => set({ onlyDevelopers })
}));

export default useOnlyDevelopers;
